import { render, staticRenderFns } from "./pointRoute.vue?vue&type=template&id=3e865342&scoped=true"
import script from "./pointRoute.vue?vue&type=script&lang=js"
export * from "./pointRoute.vue?vue&type=script&lang=js"
import style0 from "./pointRoute.vue?vue&type=style&index=0&id=3e865342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e865342",
  null
  
)

export default component.exports